// Convert Object To Array
const getValueFromObj = (obj, key) => obj[key]
const objectToArray = (obj, reducer = getValueFromObj) => Object.keys(obj).map(key => reducer(obj, key))

// Convert Array To Object
const extendObject = (key) => (acc, next, index) => {
  const k = key ? next[key] : index
  acc[k] = next
  return acc
}
const arrayToObject = (arr, key) => arr.reduce(extendObject(key), {})

export {
  objectToArray,
  arrayToObject
}
